import PropTypes from 'prop-types'
import { NavLink } from 'react-router-dom'

const Toolbar = ({ children, routes, style }) => {
  return (
    <nav className="ctp-toolbar-menu" style={style}>
      <ul>
        {children ||
          routes.map(
            ({ path, name, hidden, disabled }) =>
              !hidden && (
                <li key={name}>
                  <NavLink
                    to={path}
                    onClick={(e) => disabled && e.preventDefault()}
                    className={({ isActive }) => (isActive ? 'is-active' : '')}
                  >
                    <span style={{ width: '160px' }}>{name}</span>
                  </NavLink>
                </li>
              ),
          ) ||
          null}
      </ul>
    </nav>
  )
}

Toolbar.propTypes = {
  routes: PropTypes.arrayOf(
    PropTypes.shape({ path: PropTypes.string, name: PropTypes.string, hidden: PropTypes.bool }),
  ),
  children: PropTypes.node,
  style: PropTypes.object,
}

Toolbar.Item = ({ children }) => {
  return <li>{children}</li>
}

Toolbar.Item.displayName = 'Toolbar.Item'

Toolbar.Item.propTypes = {
  children: PropTypes.node,
}

export default Toolbar
